    <div class="modal-header navbar-alertia">
        <h4 class="modal-title">{{'user.user_bulk_import' | translate}}</h4>
        <button type="button" class="close" (click)="activeModal.close()">&times;</button>
    </div>
    <div class="modal-body">
        <!--Show/hide instructions-->
        <div id="bulk_instructions">
            <h4>{{'bulk_import.title' | translate}} </h4>
            <ul>
                <li>{{'bulk_import.inst_format' | translate}}</li> 
                <li>{{'bulk_import.inst_example' | translate}} (<button class="btn sample-file" (click)="saveAsExcelFile('csv')">.csv</button>, <button class="btn sample-file" (click)="saveAsExcelFile('xlsx')">.xlsx</button>).</li>
                <li>{{'bulk_import.max_users' | translate}}</li>
                <li><strong>{{'general.important' | translate}}:</strong> {{'bulk_import.user_role' | translate}}</li>
                <li>{{'bulk_import.inst_invalid' | translate}}</li>
                <li>{{'bulk_import.inst_message' | translate}}</li>
                <li>{{'bulk_import.inst_close' | translate}}</li>
            </ul>
        </div>
        <div id="output_message" class="pt-2"></div>
        <div class="row">
            <div id="error_message" class="col-12 error text-center"></div>
        </div> 
        <form class="w-100" (ngSubmit)="saveBulkImport()" novalidate>
            <div class="row" id="bulk_upload">
                <div class="col-12">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang" title="{{'general.select' | translate}}"
                            (change)="handleBulkImportUpload($event)" (click)="resetFile($event)">
                        <div class="custom-file-label custom-label" id="fileLabel" title="{{'general.select' | translate}}"></div>
                    </div>
                </div>
            </div>
            <div class="row text-center">
                <div id="type-error" class="error col-12 mt-2"></div>
            </div>
            <div id="buttons_bulk">
                <hr class="hr-m">
                <div class="row">
                    <div class="col-12 text-right">
                        <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2" id="cancel_bulk" (click)="activeModal.close()">
                            {{'general.cancel' | translate}}
                        </button>
                        <button type="submit" title="{{'general.add' | translate}}" class="btn btn-green btn-dis-green btn-h-green" id="add_bulk" disabled>
                            {{'general.add' | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <div id="ok_button" hidden>
                <hr class="hr-m">
                <div class="row">
                    <div class="col-12 text-right">
                        <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-blue btn-h-blue" (click)="activeModal.close(false)">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <ngx-spinner bdColor="rgba(51,51,51,0.55)"
            size="medium"
            color="#fff"
            type="line-spin-clockwise-fade"
            [fullScreen]="false">
            <p class="loading">{{ 'general.loading' | translate }}...</p>
        </ngx-spinner>
    </div>
    